import { RuleResult } from 'types/DeclarationP5'

const C0403Validator = {
  validatePlaceOfLoadingRequirement: ({
    additionalDeclarationType,
  }: {
    additionalDeclarationType: string
  }): RuleResult => (additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'),
}

export default C0403Validator
